<template>
    <v-snackbar
        :bottom="position.includes('bottom')"
        :right="position.includes('right')"
        :left="position.includes('left')"
        :top="position.includes('top')"
        :alert-type="_.isString(alertType) ? alertType : null"
        :multi-line="_.isBoolean(multiLine) ? multiLine : false"
        :value="index === 0"
        :vertical="_.isBoolean(vertical) ? vertical : false"
        :timeout="_.isNumber(timeout) ? timeout : -1"
        :elevation="_.isBoolean(elevation) ? elevation : 6"
        color="background"
    >
        <v-row :class="alertTextColor" align="center" no-gutters>
            <v-col v-if="alertIcon" class="shrink">
                <v-icon left :color="alertColor">{{ alertIcon }}</v-icon>
            </v-col>
            <v-col class="grow">
                <slot name="text" />
            </v-col>
        </v-row>

        <template #action="{ attrs }">
            <app-button
                v-if="_.isFunction(retry)"
                v-test-id="{ page: 'snack' }"
                v-bind="attrs"
                small
                secondary
                :text="$t('retry')"
                class="mr-2"
                @click="onRetry"
            />
            <slot v-if="findSlot('action')" name="action" v-bind="{ attrs }" />
            <app-button
                v-else
                icon="close"
                :color="'grey darken-2'"
                v-bind="attrs"
                small
                @click="$emit('remove', id)"
            />
        </template>
    </v-snackbar>
</template>

<script>
import alert from '@/mixins/alert';
import { mapGetters } from 'vuex';

export default {
    name: 'AppSnack',
    mixins: [alert],
    props: {
        id: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        alertType: {
            type: String,
            default: null
        },
        multiLine: {
            type: Boolean,
            default: false
        },
        vertical: {
            type: Boolean,
            default: false
        },
        timeout: {
            type: Number,
            default: -1
        },
        elevation: {
            type: Number,
            default: 6
        },
        retry: {
            type: Function,
            default: null
        },
        position: {
            type: String,
            default: 'bottom-right'
        }
    },
    computed: {
        ...mapGetters('snackQueue', ['items', 'processing'])
    },
    methods: {
        onRetry() {
            this.retry();
            this.$emit('remove', this.id);
        }
    }
};
</script>
